// Brand + content data for Zuerich Airport Taxi — Schweizer Flughafentransfer

export const COMPANY = {
  name: "Zuerich Airport Taxi",
  logo: "https://static.prod-images.emergentagent.com/jobs/13d26cbe-00f1-49ff-b27d-9375962706dd/images/7d472a85f6e3401fc106183220936806efc3d6e7e11baadf707b6f423ee4e04a.png",
  logoLight: "https://static.prod-images.emergentagent.com/jobs/13d26cbe-00f1-49ff-b27d-9375962706dd/images/52c8053b93ccbd81c6f84f987a2970ac68ea482ab44fa15b114e4836335df2a8.png",
  phone: "+41 79 177 24 24",
  officePhone: "+41 44 594 21 12",
  officePhoneRaw: "+41445942112",
  phoneRaw: "+41791772424",
  whatsapp: "41791772424",
  email: "info@zuerichairporttaxi.ch",
  address: "Blumenfeldstrasse 1, 8046 Zürich",
  rating: "4.8",
  reviewCount: 451,
};

export const NAV_LINKS = [
  { label: "Buchen", tkey: "nav_book", to: "/booking" },
  { label: "Reiseziele", tkey: "nav_destinations", to: "/staedte" },
  { label: "Preise", tkey: "nav_prices", to: "/preise" },
  { label: "Events", tkey: "nav_events", to: "/events", isEvent: true },
  { label: "Ablauf", tkey: "nav_how", href: "/#how" },
  { label: "Blog", tkey: "nav_blog", to: "/blog" },
  { label: "Kontakt", tkey: "nav_contact", to: "/kontakt" },
  { label: "Buchung prüfen", tkey: "nav_status", to: "/status" },
];

export const HERO = {
  image:
    "https://images.pexels.com/photos/15774577/pexels-photo-15774577.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1000",
  title: "Ihr zuverlässiger Flughafentransfer in der Schweiz",
  subtitle:
    "Festpreise, professionelle Chauffeure und Flugverfolgung bei jeder Fahrt in der ganzen Schweiz – buchen Sie Ihren privaten Transfer in unter einer Minute.",
  badges: ["Kostenlose Stornierung", "Flugverfolgung", "24/7 Support", "Meet & Greet"],
};

export const CORE_SERVICES = [
  { title: "Ganze Schweiz", desc: "Von jedem Flughafen zu jeder Stadt und jedem Bergdorf in der Schweiz.", icon: "Globe" },
  { title: "Professionelle Chauffeure", desc: "Lizenzierte, geprüfte Chauffeure für pünktliche und entspannte Fahrten.", icon: "BadgeCheck" },
  { title: "Chauffeur stundenweise", desc: "Buchen Sie einen persönlichen Chauffeur stundenweise für Geschäft oder Freizeit.", icon: "Clock" },
  { title: "Stadt-zu-Stadt-Fahrten", desc: "Entdecken Sie jede Stadt, jederzeit – auch über lange Distanzen.", icon: "Building2" },
];

export const HOW_IT_WORKS = [
  { step: "1", title: "Route eingeben & Fahrzeug wählen", desc: "Füllen Sie die Suchfelder aus und wählen Sie das passende Fahrzeug." },
  { step: "2", title: "Buchung abschliessen", desc: "Passagierdaten und Extras hinzufügen, sicher bezahlen und Voucher erhalten." },
  { step: "3", title: "Chauffeur treffen", desc: "Sie erhalten die Fahrerdaten vor der Abholung – er wartet mit Namensschild auf Sie." },
];

export const FEATURES = [
  { title: "Festpreise", desc: "Transparente Preise, keine Überraschungen.", icon: "BadgeCheck" },
  { title: "Hochwertige Fahrzeuge", desc: "Nur die besten aktuellen Modelle.", icon: "Car" },
  { title: "Sichere Fahrten", desc: "Geschulte Profis, zuverlässige Abholung.", icon: "ShieldCheck" },
  { title: "Flugverfolgung", desc: "Wir passen uns Ihrer Ankunft an, rund um die Uhr.", icon: "PlaneLanding" },
];

export const REVIEWS = [
  { name: "Sophie", initial: "S", date: "3. Juli 2026", text: "Der Fahrer hat trotz langer Grenzkontrollen geduldig gewartet. Deutlich weniger Stress für uns – absolut empfehlenswert." },
  { name: "Andreas", initial: "A", date: "2. Juli 2026", text: "Freundlicher, geduldiger Fahrer und ein makelloses Fahrzeug. Von der Buchung bis zur Ankunft alles perfekt." },
  { name: "Lima", initial: "L", date: "2. Juli 2026", text: "Einfache Buchung, Fahrer pünktlich und ein reibungsloser Anschluss. Genau das, was man für Geschäftsreisen braucht." },
  { name: "Daniel", initial: "D", date: "1. Juli 2026", text: "Hilfsbereiter und höflicher Fahrer. Komfortabler Van und eine ruhige, sichere Fahrt." },
  { name: "Marlène", initial: "M", date: "30. Juni 2026", text: "Perfekter Transfer. Perfektes Auto und Fahrer. Wir waren mit dem Service sehr zufrieden." },
  { name: "Coiffard", initial: "C", date: "28. Juni 2026", text: "Das Team war professionell, pünktlich und blieb in Kontakt. Der Kundenservice war sehr professionell." },
];

// Legacy exports kept for compatibility
export const PARTNERS = [];
export const SERVICES = [];
export const EXPERIENCE = [];
export const FLEET = [];
export const JOURNAL = [];
export const LOCATIONS = ["Flughafen Zürich (ZRH)", "Zürich HB", "Davos", "St. Moritz", "Zermatt", "Luzern", "Bern", "Basel", "Genf", "Interlaken"];
